import { AddressBookBackup } from '@/store/addressBook';
import { z } from 'zod';

export default function useBackupChecker() {
  const check = (backup: AddressBookBackup) => {
    const addressSchema = z.object({
      name: z.string().optional(),
      address: z.string(),
    });

    const schema = z.object({
      items: z.array(addressSchema),
      bundles: z.array(
        z.object({
          name: z.string().optional(),
          items: z.array(addressSchema),
        }),
      ),
    });

    const parsed = schema.safeParse(backup);

    if (parsed.error) {
      console.error(parsed.error);
    }

    return parsed.success;
  };

  return { check };
}
